<template>
    <div>
        <v-card>
            <v-alert class="mt-12" color="primary" dark border="left">
            GYM VIRTUAL DE INTELIGENIO
            </v-alert>
        </v-card>
        <v-btn color="error" class="ma-2 white--text" @click="goBack">
      <v-icon left>
        mdi-arrow-left
      </v-icon>
      Volver
    </v-btn>
        <!-- <pre>{{ estudianteData }}</pre> -->
        <v-card-title class="d-flex justify-center py-2" >{{estudianteData.level}}</v-card-title>
        <video width="1100" height="480" controls controlslist="nodownload noplaybackrate"> 
          <source :src="iframeUrl" type="video/mp4">
        </video>
       
    </div>
</template>
<script>
// import axios from '../../../helpers/axios'
// import {mapState} from 'vuex';



export default {
    
    components:{
    },
    
    data (){
    return {
    estudianteResponse:[
      {
        titulo: "Rutina 01",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/Rutina01.mp4",
    },
    {
        titulo: "Rutina 02",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/Rutina02.mp4",
    },
    {
        titulo: "Rutina 03",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/Rutina03.mp4",
    },
    {
        titulo: "Rutina 04",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/rutina04.mp4",
    },
    {
        titulo: "Rutina 05",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/Rutina05.mp4",
    },
    {
        titulo: "Rutina 06",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/Rutina06.mp4",
    },
    {
        titulo: "Rutina 07",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/Rutina07.mp4",
    },
    {
        titulo: "Rutina 08",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/Rutina08.mp4",
    },
    {
        titulo: "Rutina 09",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/Rutina09.mp4",
    },
       {
        titulo: "Rutina 10",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/Rutina10.mp4",
    },
       {
        titulo: "Rutina 11",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/Rutina11.mp4",
    },
       {
        titulo: "Rutina 12",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/primaria/Rutina12.mp4",
    },
       {
        titulo: "Rutina 1",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/secundaria/rutina01.mp4",
    },
    {
        titulo: "Rutina 2",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/secundaria/Rutina2.mp4",
    },
    {
        titulo: "Rutina 3",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/secundaria/Rutina3.mp4",
    },
    {
        titulo: "Rutina 4",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/secundaria/Rutina4.mp4",
    },
    {
        titulo: "Rutina 5",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/secundaria/Rutina5.mp4",
    },
    {
        titulo: "Rutina 6",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/secundaria/Rutina6.mp4",
    },
    {
        titulo: "Rutina 7",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/secundaria/Rutina7.mp4",
    },
    {
        titulo: "Rutina 8",
        url: "https://s3-inteligenio-test.s3.amazonaws.com/recurso/GymVirtual/secundaria/Rutina8.mp4",
    }
    
    ],

    estudianteData: this.getEstudianteData()
    };
       
    },


    mounted() {
          
    },

    computed: {
        iframeUrl() {
        const match = this.estudianteResponse.find(item => item.titulo === this.estudianteData.level);
        console.log("match: " , match)
        return match ? match.url : '';
        }
    },    

    methods: {
    goBack() {
      this.$router.push({ name: 'gymVirtualList' });
    },
    getEstudianteData() {
      let data = { level: this.$route.params.level, estudianteData: this.$route.params.estudianteData };
      return data;
    },
  },
};
</script>



<style scoped>

</style>